import { useCallback, useMemo, useRef, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useAppStateProvider } from "../../../contextProviders/AppStateProvider";
import createTranslator from "../../../util/translationHelper";
import messages from "../translations/messages";
import helper from "./termsHelper";
import useAccountingFeatureFlag from "../useAccountingFeatureFlag";
import useAccountingGuard from "../useAccountingGuard";
import { SUBSCRIPTION_STATUS } from "../constants";
import getToken from "../../../util/tokenGenerator";
import { handleTokenRequest } from "../../../util/helper";


function useTerms(props) {
  const { lang, history } = props;
  const BLOCK = useRef("qbo-terms");
  const { appState } = useAppStateProvider();
  const isChangePlanMode = appState?.changePlanMode === true;
  const { instance, inProgress, accounts } = useMsal();
  const getTokenHandler = () => getToken(instance, inProgress, accounts);
  const tokenhandler = async () => await handleTokenRequest(getTokenHandler);

  useAccountingFeatureFlag({ lang, history });
  const { isReady, subscription } = useAccountingGuard({ lang, history, skip: isChangePlanMode });
  const [isLoading, setIsLoading] = useState(false);
  const [acceptContinue, setAcceptContinue] = useState(false);
  const [acceptTC, setAcceptTC] = useState(false);

  const isConditionAccepted = acceptContinue && acceptTC;

  // OMS flow: subscription already created via OMS Kafka event (status = PENDING)
  const isOmsFlow = subscription?.status === SUBSCRIPTION_STATUS.PENDING;

  const translate = useMemo(() => {
    return createTranslator(messages);
  }, [createTranslator, messages]);

  const handleAccept = useCallback(async () => {
    if (!isConditionAccepted) return;

    if (isChangePlanMode) {
      history.push(`/${lang}/qbo-accounting/oauth-callback`);
      return;
    }

    try {
      setIsLoading(true);
      await helper.confirmTerms(tokenhandler, (popupUrl) => {
        if (popupUrl) {
          window.location.href = popupUrl;
        }
      });
    } finally {
      setIsLoading(false);
    }
  }, [isConditionAccepted, isChangePlanMode, lang, history, setIsLoading]);

  const handleBack = useCallback(() => {
    history.push(`/${lang}/qbo-accounting/pricing`);
  }, [lang, history]);

  return {
    BLOCK,
    translate,
    isLoading,
    isReady,
    isOmsFlow,
    acceptContinue,
    setAcceptContinue,
    acceptTC,
    setAcceptTC,
    isConditionAccepted,
    handleAccept,
    handleBack,
  };
}

const Hook = {
  useTerms,
};

export default Hook;
